/* eslint-disable no-unused-vars */

export enum Estado {
    PAGADO = "PAGADO",
    PENDIENTE = "PENDIENTE",
    CANCELADO = "CANCELADO",
    ARREPENTIDO = "ARREPENTIDO"
}
